import React, { useState } from 'react';
import { RequiredDialogInput, DialogInput, handleInputChange, RequiredDialogSelect, DialogCheckbox } from '../DialogInputs';
import { useSaveBusinessUnit } from '../../../../hooks/useBusinessUnits';
import CommonConfigDialog from './CommonConfigDialog';
import { useGetSites } from '../../../../hooks/useSites';
import { usePrivileges } from '../../../../hooks/usePrivileges';
import { useTranslation } from 'react-i18next';

function BusinessUnitEditDialog({ dialogData, setDialogData, showDialog, closeDialog }) {

    const { t } = useTranslation();

    const [fieldErrors, setFieldErrors] = useState({});
    const { admin } = usePrivileges();

    const { saveBusinessUnit } = useSaveBusinessUnit();
    const { sites } = useGetSites();

    const onChange = (e) => {
        handleInputChange(e, dialogData, setDialogData, fieldErrors, setFieldErrors);
    }

    return (
        <CommonConfigDialog title={"Business Unit - " + dialogData.name} dialogData={dialogData} showDialog={showDialog} closeDialog={closeDialog} save={saveBusinessUnit} fieldErrors={fieldErrors} setFieldErrors={setFieldErrors} >
            <RequiredDialogInput controlId="formBusinessUnitName" title="Name" placeholder="Business Unit Name" name="name" value={dialogData.name} error={fieldErrors.name} onChange={onChange} />
            <RequiredDialogSelect controlId="formBusinessUnitSite" title="Site" name="siteId" value={dialogData.siteId} error={fieldErrors.siteId} onChange={onChange}>
                <option value="" key={0} >{t('Application.Controls.DefaultSelect')}</option>
                {sites.map((site) => <option value={site.id} key={site.id}>{site.name}</option>)}
            </RequiredDialogSelect>
            <DialogInput controlId="formBusinessUnitDisplay" title="Display" placeholder="Display" name="display" value={dialogData.display} error={fieldErrors.display} onChange={onChange} />
            <DialogInput controlId="formBusinessUnitADGroupName" title="AD Group Name" placeholder="AD Group Name" name="adGroupName" value={dialogData.adGroupName} error={fieldErrors.adGroupName} onChange={onChange} />
            {admin && <DialogCheckbox controlId="formBusinessUnitUsesSubCategories" title="Use Sub Categories" name="usesSubCategories" checked={dialogData.usesSubCategories} onChange={onChange}></DialogCheckbox>}
        </CommonConfigDialog>
    );
}

export default BusinessUnitEditDialog;